import {Component, inject, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {NotificationService} from "../../services/notification.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {passwordValidator} from "../../shared/validators/input-validators";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})

export class ChangePasswordComponent implements OnInit {
  form: FormGroup;
  loading = false;
  // password
  showPassword: boolean = true;
  showPassword2: boolean = true;
  showPassword3: boolean = true
  token: string;
  private readonly fb: FormBuilder = inject(FormBuilder)
  private readonly authService: AuthService = inject(AuthService)
  private readonly notificationService: NotificationService = inject(NotificationService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);
  private readonly location: Location = inject(Location)

  constructor() {
  }

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.paramMap.get("token")
    this.form = this.fb.group({
      newPassword: [null, [Validators.required, Validators.pattern(passwordValidator)]],
      confirmPassword: [null, Validators.required],
      oldPassword: [null, Validators.required],
    });
  }

  submitForm(value) {
    // // console.log(value)
    if (value.newPassword === value.confirmPassword) {
      let data = {
        newPassword: value.newPassword,
        oldPassword: value.oldPassword,
      }
      this.authService.changePassword(data).then(
        async () => {
          await this.authService.logout();
        }
      )
    } else {
      this.notificationService.errorMessage("New Password and Confirm Password do not match");
    }
  }

  goBack() {
    this.location.back();
  }
}
